import React from "react";
import OpportunityCard from "./OpportunityCard";
import Icon from "components/AppIcon";

export default function OpportunityGrid({ opportunities, bookmarks, onBookmarkToggle, isLoading, isExternal, stateOverrides, onRequestAccess }) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {Array.from({ length: 6 })?.map((_, i) => (
          <div key={i} className="bg-card border border-border rounded-xl overflow-hidden shadow-xs">
            <div className="skeleton h-44 w-full" />
            <div className="p-4 space-y-3">
              <div className="skeleton h-5 w-3/4 rounded" />
              <div className="skeleton h-4 w-1/2 rounded" />
              <div className="grid grid-cols-2 gap-3">
                {Array.from({ length: 4 })?.map((_, j) => (
                  <div key={j} className="skeleton h-14 rounded-lg" />
                ))}
              </div>
              <div className="skeleton h-10 w-full rounded-lg" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (opportunities?.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
          <Icon name="SearchX" size={28} color="var(--color-muted-foreground)" />
        </div>
        <h3 className="font-heading font-semibold text-foreground text-xl mb-2">No opportunities found</h3>
        <p className="text-muted-foreground font-body text-sm max-w-sm">
          Try adjusting your filters or search terms to discover more infrastructure deals.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
      {opportunities?.map((opp) => (
        <OpportunityCard
          key={opp?.id}
          opportunity={opp}
          isBookmarked={bookmarks?.includes(opp?.id)}
          isExternal={isExternal}
          onBookmarkToggle={onBookmarkToggle}
          stateOverrides={stateOverrides}
          onRequestAccess={onRequestAccess}
        />
      ))}
    </div>
  );
}